// extracted by mini-css-extract-plugin
export default {"similarCategories":"SimilarCategories_similarCategories__837KH","categories":"SimilarCategories_categories__cxRVh"};